import type { RunSummary } from '@/entities/sender.entity';

const SOURCE_LABELS: Record<NonNullable<RunSummary['runSource']>, string> = {
	panel_manual: 'Ручной',
	panel_auto_campaign: 'Авто',
	landing: 'Лендинг',
	device: 'Устройство',
};

export function formatRunSourceLabel(runSource: RunSummary['runSource']): string {
	if (!runSource) return 'Ручной';
	return SOURCE_LABELS[runSource] ?? 'Ручной';
}

export function formatRunRelativeTime(createdAt: string, nowMs = Date.now()): string {
	const then = Date.parse(createdAt);
	if (!Number.isFinite(then)) return '';
	const diffSec = Math.round((then - nowMs) / 1000);
	const abs = Math.abs(diffSec);
	const rtf = new Intl.RelativeTimeFormat('ru', { numeric: 'auto' });

	if (abs < 60) return rtf.format(diffSec, 'second');
	const diffMin = Math.round(diffSec / 60);
	if (Math.abs(diffMin) < 60) return rtf.format(diffMin, 'minute');
	const diffHour = Math.round(diffMin / 60);
	if (Math.abs(diffHour) < 24) return rtf.format(diffHour, 'hour');
	const diffDay = Math.round(diffHour / 24);
	if (Math.abs(diffDay) < 7) return rtf.format(diffDay, 'day');
	return new Date(then).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}

export type RunCardStatsLine =
	| { kind: 'none' }
	| { kind: 'counts'; delivered: number; scheduled: number }
	| { kind: 'delivered'; delivered: number };

export function resolveRunCardStats(run: RunSummary): RunCardStatsLine {
	const delivered = run.deliveredCount ?? 0;
	const scheduled = run.scheduledCount ?? 0;
	if (scheduled > 0) {
		return { kind: 'counts', delivered, scheduled };
	}
	if (delivered > 0) {
		return { kind: 'delivered', delivered };
	}
	return { kind: 'none' };
}

export function formatRunCardMetaLine(run: RunSummary, nowMs?: number): string {
	const parts = [formatRunRelativeTime(run.createdAt, nowMs), formatRunSourceLabel(run.runSource)];
	if (run.landingHostname) {
		parts.push(run.landingHostname);
	} else if (run.sessionLabel) {
		parts.push(run.sessionLabel);
	}
	return parts.filter(Boolean).join(' · ');
}
